import './spinner.css';
import { useSpinnerContext } from '@contexts';

function Spinner() {
    const { show } = useSpinnerContext();

    return <div id="cover-spin" style={{ display: show ? `block` : `none` }} />;
}

export default Spinner;
